module.exports = __webpack_public_path__ + "img/user-three.717c343c.svg";